export default {
  welcomeBack: 'مرحبًا بعودتك',
  loginToYourAccount: 'تسجيل الدخول إلى حسابك',
  dontHaveAnAccountYet: 'لا تملك حسابا بعد؟',
  createAccount: 'إنشاء حساب',
};
